import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Linkedin } from "lucide-react";

const teamMembers = [
  {
    name: "Prashanth Krotha",
    role: "Founder",
    bio: "MIT MBA, Cybersecurity Expert, Builder. Passionate about making Education Accessible.",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/prashanth.jpeg",
    linkedin: "https://www.linkedin.com/in/prashanthkrotha/",
  },
  {
    name: "Teja Puvvula",
    role: "Technology Lead, Partner",
    bio: "Experienced EdTech & AdTech Builder. Passionate about education equity.",
    image: "https://ca.slack-edge.com/T07KXQZ9TQ9-U07L80HD1FA-9b4c5766145e-512",
    linkedin: "https://www.linkedin.com/in/teja-puvvula-a98368210/",
  },
  {
    name: "Venkat Malisetti",
    role: "CFO, Partner",
    bio: "MIT MBA, Private Equity, Entrepreneur, Investor.",
    image:
      "https://stagingonegrad.blob.core.windows.net/fe-assets/onegrad-advisors/venkat.jpeg",
    linkedin: "https://www.linkedin.com/in/narasimharaomalisetti/",
  },
];

export default function CoreTeamSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section id="team" className="py-10 md:py-20 bg-white w-full" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Our Core Team
          </h2>
          <p className="text-xl text-gray-600 font-medium max-w-2xl mx-auto">
            We've been through this journey ourselves.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={member.name}
              className="group bg-white rounded-2xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
            >
              <div className="text-center">
                <div className="relative mb-6">
                  <img
                    src={member.image}
                    alt={member.name}
                    width={120}
                    height={120}
                    className="rounded-full mx-auto shadow-lg"
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-[#80E280] font-bold text-lg mb-2">
                  {member.role}
                </p>
                <p className="text-gray-600 text-base leading-relaxed mb-4">
                  {member.bio}
                </p>
                <motion.a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full hover:bg-[#80E280] hover:text-white transition-colors duration-200 opacity-0 group-hover:opacity-100"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Linkedin size={18} />
                </motion.a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
